import { useEffect, useState } from "react";
import { useAuth } from "../useContext";
import { AuthRolType } from "../../context";
import { hasPermission } from "../../components";

export const usePermissionGuard = (allowedRoles: AuthRolType[]) => {
  const { rol } = useAuth();

  const [isAuthorized, setIsAuthorized] = useState<boolean>(false);

  useEffect(() => {
    setIsAuthorized(hasPermission(rol, allowedRoles));
  }, [rol, allowedRoles]);

  return { isAuthorized };
};
